import React from 'react';
import { useT } from '../services/i18n';

const HomeHero = () => {
  const { t } = useT();
  return (
    <section className="bg-gray-100 pt-6 sm:pt-8" data-testid="home-hero">
      <div className="max-w-7xl mx-auto px-4">
        <h1 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-gray-900 leading-tight tracking-tight" data-testid="home-h1">
          {t('home.h1')}
        </h1>
        <p className="mt-2 text-sm sm:text-base text-gray-600 max-w-3xl" data-testid="home-h1-sub">
          {t('home.h1Sub')}
        </p>
      </div>
    </section>
  );
};

export default HomeHero;
